// update state
const setActionFolderNotifications = (payload) => {
    return {
        type: "ACTIONFOLDERNOTIFICATION",
        payload
    }
}

export default setActionFolderNotifications;


// WEBPACK FOOTER //
// ./src/actions/setActionFolderNotifications.js